import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  MasterAdminDashboardDTO,
  MasterAdminDashboardService,
} from '../tokens/master-admin-dashboard.token';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-only implementation of `MasterAdminDashboardService`.
 *
 * Calls GET /services/embedded/api/master-admin/dashboard.
 * Rule 07 / Rule 10 — no mock fallback. Playwright tests intercept via `page.route()`.
 *
 * Authority required: ROLE_MASTER_ADMIN (enforced server-side and by roleGuard on the route).
 */
@Injectable()
export class MasterAdminDashboardRestService implements MasterAdminDashboardService {
  private readonly http = inject(HttpClient);

  getDashboard(): Observable<MasterAdminDashboardDTO> {
    return this.http.get<MasterAdminDashboardDTO>(
      `${API_PATHS.EMBEDDED_API_BASE}/master-admin/dashboard`,
    );
  }
}
